import {connect} from "react-redux";
import Payments from "./Payments";
import {
    getPaymentList,
    getPaymentRequestList,
    getTrafficReportsList,
    requestPayment,
    cancelPaymentRequest
} from "../../actions/payments";
import {
    getPaymentDetailsList, 
    createPaymentDetails, 
    modifyPaymentDetails
} from "../../actions/paymentDetails"
import {setReadyForPayment} from "../../actions/auth_dialer";

const mapStateToProps = ({payments, paymentDetails, auth, auth_dialer, references}) => ({
    permissions: auth.permissions,
    
    paymentItems: payments.paymentItems,
    paymentItemsLoading: payments.paymentItemsLoading,

    paymentRequestItems: payments.paymentRequestItems,
    paymentRequestLoading: payments.paymentRequestLoading,
    
    paymentTrafficReportsItems: payments.paymentTrafficReportsItems,
    paymentTrafficReportsLoading: payments.paymentTrafficReportsLoading,
    
    paymentDetailsItems: paymentDetails.items,
    
    accountInfo: auth_dialer.dialerInfo,
    readyForPayment: auth_dialer.readyForPayment,
    
    organizationTypeList: references.organization_type_list,
    countryList: references.country_list,
    paymentMethodList: references.payment_method_list,

    globalSettings: references.global_setting,
});

export default connect(mapStateToProps, {
    getPaymentList,
    getPaymentRequestList,
    getTrafficReportsList,
    getPaymentDetailsList,
    requestPayment,
    cancelPaymentRequest,

    createPaymentDetails,
    modifyPaymentDetails,
    setReadyForPayment,
})(Payments);